export const appNameWord = "oCRvwe";
export default {appNameWord};